export default __webpack_public_path__ + "static/char-s-sp03-en-32bc7d286569037370c9bd3f1284836a.webp";